import { Box, BoxProps } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { Typography } from "src/UILibrary"
import SunEditor, { buttonList } from "suneditor-react"
import lang from "suneditor/src/lang"
import "suneditor/dist/css/suneditor.min.css"

interface Props {
  sx?: BoxProps
  title?: string
  content?: string
  className?: any
  required?: boolean
  labelStyle?: any
  validationMessage?: string
  handleChange?: any
}
export const HTMLEditor = ({
  sx,
  title,
  content,
  className,
  required,
  labelStyle,
  validationMessage,
  handleChange,
}: Props) => {
  const style = sx || {}
  const { t } = useTranslation("translation", { keyPrefix: "base" })
  return (
    <>
      <Box
        className={`input_text ${className}`}
        sx={{
          height: "100%",
          ...style,
        }}
      >
        {title && (
          <Box display="flex" sx={{ mb: "20px" }}>
            <Typography.InputFieldTitle sx={{ mr: "6px", color: "text.primary", ...labelStyle }}>
              {title}
            </Typography.InputFieldTitle>
            {required && (
              <Box
                sx={{
                  px: "8px",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  borderRadius: "4px",
                  borderColor: "text.border",
                }}
              >
                <Typography.InputFieldRequired sx={{ m: "auto", color: "text.border" }}>
                  {t("required")}
                </Typography.InputFieldRequired>
              </Box>
            )}
          </Box>
        )}
        <SunEditor
          setOptions={{
            height: "100px",
            buttonList: [...buttonList.complex],
            lang: lang.ja,
          }}
          defaultValue={content!}
          onChange={handleChange}
        />
        <Box sx={{ height: "20px", pt: "5px" }}>
          {validationMessage && (
            <Typography.ValidationText>{validationMessage}</Typography.ValidationText>
          )}
        </Box>
      </Box>
    </>
  )
}
